import cn from 'classnames';
import { InputHTMLAttributes, ReactNode } from 'react';

import './radio.styles.scss';

type RadioCardProps = {
    id: string;
    value: string;
    title: ReactNode;
    checked?: boolean;
    disabled?: boolean;
    className?: string;
    inputProps?: Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'id' | 'value' | 'checked'>;
    iconSlot?: ReactNode;
};

export const RadioCard = ({ id, title, value, checked, disabled, inputProps, className, iconSlot }: RadioCardProps) => {
    return (
        <label
            className={cn(
                'radio-card',
                { 'radio-card--checked': checked, 'radio-card--disabled': disabled },
                className
            )}
            htmlFor={id}
        >
            <div className="radio-card__title-container">
                <div className="radio-card__title-text">{title}</div>
                {iconSlot && <div className="radio-card__title-icon">{iconSlot}</div>}
            </div>
            <input id={id} type="radio" value={value} checked={checked} {...inputProps} className="radio-card__input" />
        </label>
    );
};
